<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            :persistent='true'
            width="70%"
            height="100%"
            class="modalDialog"
            no-click-animation
          >
            <div>
                <v-card class="cardWrap">
                    <CardTitle :title="page_title" />
                    <v-card-actions class="cardWrap__scroll">
                        <v-container>
                            <v-form
                                class="cardWrap__fromArea"
                                ref="form"
                                :lazy-validation="lazy"
                            >
                                <p>{{ from_set_data.template_name }}</p>
                                <v-textarea
                                    v-model="from_set_data.template"
                                    :rules="[rules.required]"
                                    rows="10"
                                    outlined
                                    no-resize
                                    solo
                                    autofocus
                                />
                            </v-form>
                        </v-container>
                    </v-card-actions>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="green darken-4" text @click="CloseModal">閉じる</v-btn>
                      <v-btn color="green darken-4" text v-if="addModeStatus" @click="validateCheck">登録</v-btn>
                      <v-btn color="green darken-4" text v-if="changeModeStatus" @click="changeOverlay = !changeOverlay">変更</v-btn>
                    </v-card-actions>
                </v-card>
            </div>
            <AddOverlay
              page-name="定型文"
              @processing="registerTemplateMaster"
              @cancel="addOverlay = !addOverlay"
              :process-result="process"
              :overlay-switch="addOverlay"
            />
            <ChangeOverlay
              page-name="定型文"
              @processing="updateTemplateMaster"
              @cancel="changeOverlay = !changeOverlay"
              :process-result="process"
              :OverlaySwitch="changeOverlay"
            />
        </v-dialog>
    </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import {
    REGISTER_TEMPLATE,
    UPDATE_TEMPLATE } from '@/constants/master';
import AddOverlay from '../overlay/AddOverlay';
import ChangeOverlay from '../overlay/ChangeOverlay';
import validater from '../../../../lib/validater';
import { InputPagesMixin } from './../mixin/InputPagesMixin';

export default {
    components: {
        CardTitle,
        AddOverlay,
        ChangeOverlay
    },
    mixins: [InputPagesMixin],
    props: ['editData'],
    data () {
        return {
            page_title: '定型文登録',
            // 入力値
            from_set_data: {
                // ゴルフグループ
                golf_group_code: process.env.VUE_APP_GROUP_CODE,
                // コード番号
                template_code: '',
                // コードネーム
                template_name: '',
                // 定型文
                template: ''
            },
            rules: {
                required: value => !!value || this.$t('error.validation.required.any'),
                // ゴルフ場コードバリデーション
                format_golf_code: value => !!validater.checkStringType(value) || this.$t('error.validation.stringtype'),
                // カナバリデーション
                format_kana: value => !!validater.checkKana(value) || this.$t('error.validation.kanaFormat'),
                // 郵便番号バリデーション
                format_zipcode: value => !!validater.checkZipCode(value) || this.$t('error.validation.zipCodeFormat'),
                min_length_tel: value => value.length >= 10 || this.$t('error.validation.length.tel'),
                // 電話番号バリデーション
                format_tel: value => !!validater.checkTel(value) || this.$t('error.validation.telFormat')
            }
        };
    },
    created () {
        this.Initialize();
    },
    computed: {
        addModeStatus () {
            return this.modeStatus === 'addMode';
        },
        changeModeStatus () {
            return this.modeStatus === 'changeMode';
        }
    },
    watch: {
        editData () {
            this.from_set_data.template_code = this.editData.code;
            this.from_set_data.template_name = this.editData.code_name;
            this.from_set_data.template = this.editData.template;
        },
        // modeStatusで表示を切り替える
        modeStatus () {
            if (this.modeStatus === 'addMode') {
                this.page_title = '定型文登録';
            } else if (this.modeStatus === 'changeMode') {
                this.page_title = '定型文変更';
            }
        }
    },
    methods: {
    /** ----------------------------------------------
     * 初期表示時処理
     * ---------------------------------------------- */
        Initialize () {
            this.addOverlay = false;
            this.changeOverlay = false;
            this.from_set_data = {
                code: '',
                code_name: '',
                template: ''
            };
            this.process = {
                result: '',
                resultText: ''
            };
        },
        registerTemplateMaster () {
            this.$apollo.mutate({
                mutation: REGISTER_TEMPLATE,
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    template_code: this.from_set_data.template_code,
                    template_name: this.from_set_data.template_name,
                    template: this.from_set_data.template
                }
            }).then(res => {
                this.process.result = res.data.registerTemplateMaster.result;
                this.CloseModal();
            }).catch(error => {
                this.error = error;
                this.process.result = 0;
                this.process.resultText = this.$t('result.error.add');
                this.process.result = '';
            });
        },
        updateTemplateMaster () {
            this.$apollo.mutate({
                mutation: UPDATE_TEMPLATE,
                variables: {
                    id: this.from_set_data.template_code,
                    template: this.from_set_data.template
                }
            }).then(res => {
                this.process.result = res.data.updateTemplateMaster.result;
                this.CloseModal();
            }).catch(error => {
                this.error = error;
                this.process.result = 0;
                this.process.resultText = this.$t('result.error.change');
                this.process.result = '';
            });
        },
        validateCheck () {
            if (this.$refs.form.validate()) {
                if (this.modeStatus === 'addMode') {
                    this.addOverlay = true;
                } else if (this.modeStatus === 'changeMode') {
                    this.changeOverlay = true;
                }
            }
        },
        /** ----------------------------------------------
         * 親画面にて「追加」ボタン押下時の処理
         * ---------------------------------------------- */
        addModal () {
            this.Initialize();
            this.dialog = true;
            this.modeStatus = 'addMode';
            this.$nextTick(() => {
                this.$refs.form.resetValidation();
            });
        },
        /** --------------------------------------------
        * モーダル画面を表示
        * -------------------------------------------- */
        editModal () {
            this.Initialize();
            this.dialog = true;
            this.modeStatus = 'changeMode';
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        CloseModal () {
            this.dialog = false;
            this.$refs.form.resetValidation();
            this.$emit('refresh-event');
            this.Initialize();
        }
    }
};
</script>

<style scoped>

.formHeight{
  max-width: 80%;
}

.formWidth{
  max-width: 60%;
}
</style>
